module.exports = __webpack_public_path__ + "static/media/themesberg-mockup.0d3a7e70.jpg";